import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccountLink, LazyAddonApexcharts, LazyCustomMultiselect, LazyDatepicker, LazyDivider, LazyFilterContainer, LazyFormStep, LazyFormWizard, LazyHoverOpenDiv, LazyHoverOpenDivSlot, LazyIconsSquare, LazyLoading, LazyMissionCompact, LazyMoneyText, LazyNoMatchingResults, LazyOfferStatus, LazyOfferView, LazyPageCard, LazyPaginationRecords, LazyParameterStr, LazyPaymentAccounts, LazyPaymentPlans, LazyProfileEditApprovalStatuses, LazyProfileEditBalanceHistory, LazyProfileEditBalancePoint, LazyProfileEditChangePassword, LazyProfileEditDailyBonuses, LazyProfileEdit, LazyProfileEditInvoice, LazyProfileEditMissions, LazyProfileEditNotification, LazyProfileEditPaymentAccount, LazyProfileEditPaymentPlans, LazyProfileEditPointHistory, LazyProfileEditProofs, LazyProfileEditReferenceList, LazyProfileEditReferences, LazyProfileEditRewardRequest, LazyProfileEditRoles, LazyProfileEditSameIp, LazyProfileEditSettings, LazyProfileEditSkills, LazyProfileEditSocialMedia, LazyProfileEditTicketRequest, LazyQuickOkCancelButton, LazyRewardViewInfo, LazyServiceCategoryView, LazySignupForm, LazySocialAccount, LazyStatusBaseTag, LazyStatusBaseTagMobile, LazyStoreOrderStatusBaseTag, LazyStoreOrderStatusTagMobile, LazyStoreOrdersCardCategoryDetailItem, LazyStoreOrdersCardCategory, LazyStoreOrdersCardPackageAttribute, LazyStoreOrdersCardPackage, LazyStoreOrdersHeader, LazySubscriptionStatusBaseTag, LazySubscriptionStatusBaseTagMobile, LazyTextEditor, LazyUrlLink, LazyUserAvatarComponent, LazyUserBalance, LazyUserMissionList, LazyUserPoints, LazyUserProfile, LazyUserView, LazyUserAvatar, LazyUserInfo, LazyUserViewInfo, LazyVectorIllustrationCalendar, LazyVectorIllustrationCalendarQwe, LazyAuthLandingImage, LazyBulkServicePriceDetailCard, LazyCoreAccountMenu, LazyCoreCircularMenuActivity, LazyCoreCircularMenuLanguage, LazyCoreCircularMenuNotifications, LazyCoreFlexTableCell, LazyCoreFlexTableRow, LazyCoreFlexTableStart, LazyCoreTairoCollapseCircularMenu, LazyCoreTairoCollapseLayout, LazyCoreTairoCollapseNavigation, LazyCoreTairoCollapseNavigationCollapseLinks, LazyCoreTairoCollapseToolbar, LazyCoreTairoFormSave, LazyCoreTairoPanels, LazyCoreTairoSidebarLayout, LazyCoreThemeToggle, LazyCoreToolbarAccountMenu, LazyCoreToolbarActivity, LazyCoreToolbarCoin, LazyCoreToolbarLanguage, LazyCoreToolbarMoney, LazyCoreToolbarNotifications, LazyCoreToolbarSearch, LazyCoreWizardButtons, LazyCoreWizardNavigation, LazyCoreWizardStepTitle, LazyDashboardAdmin, LazyDashboardCard, LazyDashboardCustomer, LazyDashboardCustomerMissionView, LazyDashboardCustomerStoreOrderView, LazyDashboardGraphics, LazyDashboardMissionView, LazyDashboardModerator, LazyDashboardProofView, LazyDashboardRewardRequestView, LazyDashboardSocialAccountView, LazyDashboardTicketView, LazyDashboardUser, LazyDashboardUserView, LazyDashboardWelcome, LazyForgot360Sosyal, LazyForgotGigcep, LazyGlobalAreYouSureModal, LazyGlobalLogo, LazyGoogleSignin, LazyIconAccountAt, LazyIconCheckOrXmark, LazyIconDotStatus, LazyIconGender, LazyIconInfo, LazyIconLanding1, LazyIconLanding2, LazyIconLoadingAltLoop, LazyIconTurkishLira, LazyInputColorPicker, LazyLandingFooter, LazyLandingHeader, LazyLandingTechnical, LazyLinedtextarea, LazyLoginFirst, LazyLoginTwo, LazyMenuHome, LazyMissionDetailInfo, LazyMissionDetailInfoCol, LazyMissionDetailText, LazyMissionItem, LazyMissionList, LazyMissionListItem, LazyMissionView, LazyMissionPendingProofList, LazyModalBalanceAreYouSure, LazyModalExtraDescription, LazyModalGetPerfectService, LazyModalMissionApproval, LazyModalMissionBatch, LazyModalMissionCreateUserStep, LazyModalMissionEditAdmin, LazyModalMissionProofAction, LazyModalMissionProofApproval, LazyModalMissionProofDeclineRequestAction, LazyModalMissionProofView, LazyModalMissionReportEvaluate, LazyModalMissionReportUsers, LazyModalMissionUploadProof, LazyModalNotificationCreate, LazyModalNotificationShow, LazyModalOfferIntegratedDetail, LazyModalOfferProviderSynchronization, LazyModalPackageCreate, LazyModalPaymentPlanCreate, LazyModalPaymentPlanPay, LazyModalPerfectProviderSynchronization, LazyModalProfileEmailVerify, LazyModalProfileNationalidVerify, LazyModalProfilePhoneVerify, LazyModalRateConstantsModal, LazyModalRewardRequestDetail, LazyModalRewardRequestItemStatusChange, LazyModalSocialAccountProofAction, LazyModalSocialAccountStatusChange, LazyModalSocialAccountVerifiedControl, LazyModalStatusChange, LazyModalStoreOrderCreate, LazyModalSubscriptionAction, LazyModalSubscriptionItemEdit, LazyModalTicketAction, LazyModalTicketImagePreview, LazyModalUserBanAction, LazyModalUserCreateBan, LazyModalUserOfferDetail, LazyModalUserRoleAdd, LazyModalUserSendEmail, LazyModalUserSendMessage, LazyModalUserSocialAccountProof, LazyModalWhatIsRefenceSystem, LazyModalIFrame, LazyPageBack, LazyPageHeader, LazyPageRewardRequest, LazyPageStoreOrders, LazyPreviewImages, LazyRegisterFirst, LazyRegisterTwo, LazySelectApproveType, LazySelectBoost, LazySelectDepartment, LazySelectGender, LazySelectIcons, LazySelectMissionStatus, LazySelectOneOrZero, LazySelectPackage, LazySelectParameter, LazySelectPaymentPlanStatus, LazySelectPerfectService, LazySelectPerfectServiceProvider, LazySelectPriorities, LazySelectProofStatus, LazySelectRewardCategory, LazySelectRewardItem, LazySelectRole, LazySelectService, LazySelectServiceCategory, LazySelectSocialMedia, LazySelectSocialMediaStatus, LazySelectStatus, LazySelectStoreCategory, LazySelectStoreGroup, LazySelectStorePackage, LazySelectStoreService, LazySelectSubscriptionServiceCategory, LazySelectTicketStatus, LazySelectUser, LazySelectİsDescription, LazyServiceStatusGrid, LazySubscriptionHoverOpenDiv, LazySupportWhatsapp, LazyTableHeader, LazyTableId, LazyTableCardBalancePackage, LazyTableCardOrderTrackingMission, LazyTableCardOrderTrackingSubscription, LazyTableCardPaymentPlan, LazyTableCardPriceList, LazyTableCardStoreOrder, LazyTableCardTicket, LazyTicketCards, LazyTicketDetail, LazyTicketPage, LazyViewStoreOrder, LazyWhatsappMessageForm, LazyTairoSidebarBurger, LazyTairoSidebarCircularMenu, LazyTairoSidebarLayout, LazyTairoSidebarNavigation, LazyTairoSidebarNavigationItem, LazyTairoSidebarToolbar, LazyTairoSidebarTools, LazyTairoSubsidebar, LazyTairoSubsidebarHeader, LazyTairoSubsidebarMenu, LazyTairoSubsidebarMenuCollapseLinks, LazyTairoSubsidebarMenuDivider, LazyTairoSubsidebarMenuLink, LazyTairoCollapseBurger, LazyTairoCollapseCircularMenu, LazyTairoCollapseLayout, LazyTairoCollapseNavigation, LazyTairoCollapseNavigationCollapseLinks, LazyTairoCollapseToolbar, LazyTairoTopnavCircularMenu, LazyTairoTopnavFooter, LazyTairoTopnavLayout, LazyTairoTopnavNavigation, LazyTairoLogo, LazyTairoLogoText, LazyTairoToaster, LazyTairoTocAnchor, LazyTairoCheckAnimated, LazyTairoContentWrapper, LazyTairoContentWrapperTabbed, LazyTairoError, LazyTairoFlexTable, LazyTairoFlexTableCell, LazyTairoFlexTableHeading, LazyTairoFlexTableRow, LazyTairoFormGroup, LazyTairoFormSave, LazyTairoModal, LazyTairoPanels, LazyTairoPasswordStrength, LazyTairoPopover, LazyTairoPopoverContentDual, LazyTairoPopoverContentHelp, LazyTairoPopoverContentMedia, LazyTairoTable, LazyTairoTableCell, LazyTairoTableHeading, LazyTairoTableRow, LazyTairoToc, LazyIcon, LazyIconCSS } from '#components'
const lazyGlobalComponents = [
  ["AccountLink", LazyAccountLink],
["AddonApexcharts", LazyAddonApexcharts],
["CustomMultiselect", LazyCustomMultiselect],
["Datepicker", LazyDatepicker],
["Divider", LazyDivider],
["FilterContainer", LazyFilterContainer],
["FormStep", LazyFormStep],
["FormWizard", LazyFormWizard],
["HoverOpenDiv", LazyHoverOpenDiv],
["HoverOpenDivSlot", LazyHoverOpenDivSlot],
["IconsSquare", LazyIconsSquare],
["Loading", LazyLoading],
["MissionCompact", LazyMissionCompact],
["MoneyText", LazyMoneyText],
["NoMatchingResults", LazyNoMatchingResults],
["OfferStatus", LazyOfferStatus],
["OfferView", LazyOfferView],
["PageCard", LazyPageCard],
["PaginationRecords", LazyPaginationRecords],
["ParameterStr", LazyParameterStr],
["PaymentAccounts", LazyPaymentAccounts],
["PaymentPlans", LazyPaymentPlans],
["ProfileEditApprovalStatuses", LazyProfileEditApprovalStatuses],
["ProfileEditBalanceHistory", LazyProfileEditBalanceHistory],
["ProfileEditBalancePoint", LazyProfileEditBalancePoint],
["ProfileEditChangePassword", LazyProfileEditChangePassword],
["ProfileEditDailyBonuses", LazyProfileEditDailyBonuses],
["ProfileEdit", LazyProfileEdit],
["ProfileEditInvoice", LazyProfileEditInvoice],
["ProfileEditMissions", LazyProfileEditMissions],
["ProfileEditNotification", LazyProfileEditNotification],
["ProfileEditPaymentAccount", LazyProfileEditPaymentAccount],
["ProfileEditPaymentPlans", LazyProfileEditPaymentPlans],
["ProfileEditPointHistory", LazyProfileEditPointHistory],
["ProfileEditProofs", LazyProfileEditProofs],
["ProfileEditReferenceList", LazyProfileEditReferenceList],
["ProfileEditReferences", LazyProfileEditReferences],
["ProfileEditRewardRequest", LazyProfileEditRewardRequest],
["ProfileEditRoles", LazyProfileEditRoles],
["ProfileEditSameIp", LazyProfileEditSameIp],
["ProfileEditSettings", LazyProfileEditSettings],
["ProfileEditSkills", LazyProfileEditSkills],
["ProfileEditSocialMedia", LazyProfileEditSocialMedia],
["ProfileEditTicketRequest", LazyProfileEditTicketRequest],
["QuickOkCancelButton", LazyQuickOkCancelButton],
["RewardViewInfo", LazyRewardViewInfo],
["ServiceCategoryView", LazyServiceCategoryView],
["SignupForm", LazySignupForm],
["SocialAccount", LazySocialAccount],
["StatusBaseTag", LazyStatusBaseTag],
["StatusBaseTagMobile", LazyStatusBaseTagMobile],
["StoreOrderStatusBaseTag", LazyStoreOrderStatusBaseTag],
["StoreOrderStatusTagMobile", LazyStoreOrderStatusTagMobile],
["StoreOrdersCardCategoryDetailItem", LazyStoreOrdersCardCategoryDetailItem],
["StoreOrdersCardCategory", LazyStoreOrdersCardCategory],
["StoreOrdersCardPackageAttribute", LazyStoreOrdersCardPackageAttribute],
["StoreOrdersCardPackage", LazyStoreOrdersCardPackage],
["StoreOrdersHeader", LazyStoreOrdersHeader],
["SubscriptionStatusBaseTag", LazySubscriptionStatusBaseTag],
["SubscriptionStatusBaseTagMobile", LazySubscriptionStatusBaseTagMobile],
["TextEditor", LazyTextEditor],
["UrlLink", LazyUrlLink],
["UserAvatarComponent", LazyUserAvatarComponent],
["UserBalance", LazyUserBalance],
["UserMissionList", LazyUserMissionList],
["UserPoints", LazyUserPoints],
["UserProfile", LazyUserProfile],
["UserView", LazyUserView],
["UserAvatar", LazyUserAvatar],
["UserInfo", LazyUserInfo],
["UserViewInfo", LazyUserViewInfo],
["VectorIllustrationCalendar", LazyVectorIllustrationCalendar],
["VectorIllustrationCalendarQwe", LazyVectorIllustrationCalendarQwe],
["AuthLandingImage", LazyAuthLandingImage],
["BulkServicePriceDetailCard", LazyBulkServicePriceDetailCard],
["CoreAccountMenu", LazyCoreAccountMenu],
["CoreCircularMenuActivity", LazyCoreCircularMenuActivity],
["CoreCircularMenuLanguage", LazyCoreCircularMenuLanguage],
["CoreCircularMenuNotifications", LazyCoreCircularMenuNotifications],
["CoreFlexTableCell", LazyCoreFlexTableCell],
["CoreFlexTableRow", LazyCoreFlexTableRow],
["CoreFlexTableStart", LazyCoreFlexTableStart],
["CoreTairoCollapseCircularMenu", LazyCoreTairoCollapseCircularMenu],
["CoreTairoCollapseLayout", LazyCoreTairoCollapseLayout],
["CoreTairoCollapseNavigation", LazyCoreTairoCollapseNavigation],
["CoreTairoCollapseNavigationCollapseLinks", LazyCoreTairoCollapseNavigationCollapseLinks],
["CoreTairoCollapseToolbar", LazyCoreTairoCollapseToolbar],
["CoreTairoFormSave", LazyCoreTairoFormSave],
["CoreTairoPanels", LazyCoreTairoPanels],
["CoreTairoSidebarLayout", LazyCoreTairoSidebarLayout],
["CoreThemeToggle", LazyCoreThemeToggle],
["CoreToolbarAccountMenu", LazyCoreToolbarAccountMenu],
["CoreToolbarActivity", LazyCoreToolbarActivity],
["CoreToolbarCoin", LazyCoreToolbarCoin],
["CoreToolbarLanguage", LazyCoreToolbarLanguage],
["CoreToolbarMoney", LazyCoreToolbarMoney],
["CoreToolbarNotifications", LazyCoreToolbarNotifications],
["CoreToolbarSearch", LazyCoreToolbarSearch],
["CoreWizardButtons", LazyCoreWizardButtons],
["CoreWizardNavigation", LazyCoreWizardNavigation],
["CoreWizardStepTitle", LazyCoreWizardStepTitle],
["DashboardAdmin", LazyDashboardAdmin],
["DashboardCard", LazyDashboardCard],
["DashboardCustomer", LazyDashboardCustomer],
["DashboardCustomerMissionView", LazyDashboardCustomerMissionView],
["DashboardCustomerStoreOrderView", LazyDashboardCustomerStoreOrderView],
["DashboardGraphics", LazyDashboardGraphics],
["DashboardMissionView", LazyDashboardMissionView],
["DashboardModerator", LazyDashboardModerator],
["DashboardProofView", LazyDashboardProofView],
["DashboardRewardRequestView", LazyDashboardRewardRequestView],
["DashboardSocialAccountView", LazyDashboardSocialAccountView],
["DashboardTicketView", LazyDashboardTicketView],
["DashboardUser", LazyDashboardUser],
["DashboardUserView", LazyDashboardUserView],
["DashboardWelcome", LazyDashboardWelcome],
["Forgot360Sosyal", LazyForgot360Sosyal],
["ForgotGigcep", LazyForgotGigcep],
["GlobalAreYouSureModal", LazyGlobalAreYouSureModal],
["GlobalLogo", LazyGlobalLogo],
["GoogleSignin", LazyGoogleSignin],
["IconAccountAt", LazyIconAccountAt],
["IconCheckOrXmark", LazyIconCheckOrXmark],
["IconDotStatus", LazyIconDotStatus],
["IconGender", LazyIconGender],
["IconInfo", LazyIconInfo],
["IconLanding1", LazyIconLanding1],
["IconLanding2", LazyIconLanding2],
["IconLoadingAltLoop", LazyIconLoadingAltLoop],
["IconTurkishLira", LazyIconTurkishLira],
["InputColorPicker", LazyInputColorPicker],
["LandingFooter", LazyLandingFooter],
["LandingHeader", LazyLandingHeader],
["LandingTechnical", LazyLandingTechnical],
["Linedtextarea", LazyLinedtextarea],
["LoginFirst", LazyLoginFirst],
["LoginTwo", LazyLoginTwo],
["MenuHome", LazyMenuHome],
["MissionDetailInfo", LazyMissionDetailInfo],
["MissionDetailInfoCol", LazyMissionDetailInfoCol],
["MissionDetailText", LazyMissionDetailText],
["MissionItem", LazyMissionItem],
["MissionList", LazyMissionList],
["MissionListItem", LazyMissionListItem],
["MissionView", LazyMissionView],
["MissionPendingProofList", LazyMissionPendingProofList],
["ModalBalanceAreYouSure", LazyModalBalanceAreYouSure],
["ModalExtraDescription", LazyModalExtraDescription],
["ModalGetPerfectService", LazyModalGetPerfectService],
["ModalMissionApproval", LazyModalMissionApproval],
["ModalMissionBatch", LazyModalMissionBatch],
["ModalMissionCreateUserStep", LazyModalMissionCreateUserStep],
["ModalMissionEditAdmin", LazyModalMissionEditAdmin],
["ModalMissionProofAction", LazyModalMissionProofAction],
["ModalMissionProofApproval", LazyModalMissionProofApproval],
["ModalMissionProofDeclineRequestAction", LazyModalMissionProofDeclineRequestAction],
["ModalMissionProofView", LazyModalMissionProofView],
["ModalMissionReportEvaluate", LazyModalMissionReportEvaluate],
["ModalMissionReportUsers", LazyModalMissionReportUsers],
["ModalMissionUploadProof", LazyModalMissionUploadProof],
["ModalNotificationCreate", LazyModalNotificationCreate],
["ModalNotificationShow", LazyModalNotificationShow],
["ModalOfferIntegratedDetail", LazyModalOfferIntegratedDetail],
["ModalOfferProviderSynchronization", LazyModalOfferProviderSynchronization],
["ModalPackageCreate", LazyModalPackageCreate],
["ModalPaymentPlanCreate", LazyModalPaymentPlanCreate],
["ModalPaymentPlanPay", LazyModalPaymentPlanPay],
["ModalPerfectProviderSynchronization", LazyModalPerfectProviderSynchronization],
["ModalProfileEmailVerify", LazyModalProfileEmailVerify],
["ModalProfileNationalidVerify", LazyModalProfileNationalidVerify],
["ModalProfilePhoneVerify", LazyModalProfilePhoneVerify],
["ModalRateConstantsModal", LazyModalRateConstantsModal],
["ModalRewardRequestDetail", LazyModalRewardRequestDetail],
["ModalRewardRequestItemStatusChange", LazyModalRewardRequestItemStatusChange],
["ModalSocialAccountProofAction", LazyModalSocialAccountProofAction],
["ModalSocialAccountStatusChange", LazyModalSocialAccountStatusChange],
["ModalSocialAccountVerifiedControl", LazyModalSocialAccountVerifiedControl],
["ModalStatusChange", LazyModalStatusChange],
["ModalStoreOrderCreate", LazyModalStoreOrderCreate],
["ModalSubscriptionAction", LazyModalSubscriptionAction],
["ModalSubscriptionItemEdit", LazyModalSubscriptionItemEdit],
["ModalTicketAction", LazyModalTicketAction],
["ModalTicketImagePreview", LazyModalTicketImagePreview],
["ModalUserBanAction", LazyModalUserBanAction],
["ModalUserCreateBan", LazyModalUserCreateBan],
["ModalUserOfferDetail", LazyModalUserOfferDetail],
["ModalUserRoleAdd", LazyModalUserRoleAdd],
["ModalUserSendEmail", LazyModalUserSendEmail],
["ModalUserSendMessage", LazyModalUserSendMessage],
["ModalUserSocialAccountProof", LazyModalUserSocialAccountProof],
["ModalWhatIsRefenceSystem", LazyModalWhatIsRefenceSystem],
["ModalIFrame", LazyModalIFrame],
["PageBack", LazyPageBack],
["PageHeader", LazyPageHeader],
["PageRewardRequest", LazyPageRewardRequest],
["PageStoreOrders", LazyPageStoreOrders],
["PreviewImages", LazyPreviewImages],
["RegisterFirst", LazyRegisterFirst],
["RegisterTwo", LazyRegisterTwo],
["SelectApproveType", LazySelectApproveType],
["SelectBoost", LazySelectBoost],
["SelectDepartment", LazySelectDepartment],
["SelectGender", LazySelectGender],
["SelectIcons", LazySelectIcons],
["SelectMissionStatus", LazySelectMissionStatus],
["SelectOneOrZero", LazySelectOneOrZero],
["SelectPackage", LazySelectPackage],
["SelectParameter", LazySelectParameter],
["SelectPaymentPlanStatus", LazySelectPaymentPlanStatus],
["SelectPerfectService", LazySelectPerfectService],
["SelectPerfectServiceProvider", LazySelectPerfectServiceProvider],
["SelectPriorities", LazySelectPriorities],
["SelectProofStatus", LazySelectProofStatus],
["SelectRewardCategory", LazySelectRewardCategory],
["SelectRewardItem", LazySelectRewardItem],
["SelectRole", LazySelectRole],
["SelectService", LazySelectService],
["SelectServiceCategory", LazySelectServiceCategory],
["SelectSocialMedia", LazySelectSocialMedia],
["SelectSocialMediaStatus", LazySelectSocialMediaStatus],
["SelectStatus", LazySelectStatus],
["SelectStoreCategory", LazySelectStoreCategory],
["SelectStoreGroup", LazySelectStoreGroup],
["SelectStorePackage", LazySelectStorePackage],
["SelectStoreService", LazySelectStoreService],
["SelectSubscriptionServiceCategory", LazySelectSubscriptionServiceCategory],
["SelectTicketStatus", LazySelectTicketStatus],
["SelectUser", LazySelectUser],
["SelectİsDescription", LazySelectİsDescription],
["ServiceStatusGrid", LazyServiceStatusGrid],
["SubscriptionHoverOpenDiv", LazySubscriptionHoverOpenDiv],
["SupportWhatsapp", LazySupportWhatsapp],
["TableHeader", LazyTableHeader],
["TableId", LazyTableId],
["TableCardBalancePackage", LazyTableCardBalancePackage],
["TableCardOrderTrackingMission", LazyTableCardOrderTrackingMission],
["TableCardOrderTrackingSubscription", LazyTableCardOrderTrackingSubscription],
["TableCardPaymentPlan", LazyTableCardPaymentPlan],
["TableCardPriceList", LazyTableCardPriceList],
["TableCardStoreOrder", LazyTableCardStoreOrder],
["TableCardTicket", LazyTableCardTicket],
["TicketCards", LazyTicketCards],
["TicketDetail", LazyTicketDetail],
["TicketPage", LazyTicketPage],
["ViewStoreOrder", LazyViewStoreOrder],
["WhatsappMessageForm", LazyWhatsappMessageForm],
["TairoSidebarBurger", LazyTairoSidebarBurger],
["TairoSidebarCircularMenu", LazyTairoSidebarCircularMenu],
["TairoSidebarLayout", LazyTairoSidebarLayout],
["TairoSidebarNavigation", LazyTairoSidebarNavigation],
["TairoSidebarNavigationItem", LazyTairoSidebarNavigationItem],
["TairoSidebarToolbar", LazyTairoSidebarToolbar],
["TairoSidebarTools", LazyTairoSidebarTools],
["TairoSubsidebar", LazyTairoSubsidebar],
["TairoSubsidebarHeader", LazyTairoSubsidebarHeader],
["TairoSubsidebarMenu", LazyTairoSubsidebarMenu],
["TairoSubsidebarMenuCollapseLinks", LazyTairoSubsidebarMenuCollapseLinks],
["TairoSubsidebarMenuDivider", LazyTairoSubsidebarMenuDivider],
["TairoSubsidebarMenuLink", LazyTairoSubsidebarMenuLink],
["TairoCollapseBurger", LazyTairoCollapseBurger],
["TairoCollapseCircularMenu", LazyTairoCollapseCircularMenu],
["TairoCollapseLayout", LazyTairoCollapseLayout],
["TairoCollapseNavigation", LazyTairoCollapseNavigation],
["TairoCollapseNavigationCollapseLinks", LazyTairoCollapseNavigationCollapseLinks],
["TairoCollapseToolbar", LazyTairoCollapseToolbar],
["TairoTopnavCircularMenu", LazyTairoTopnavCircularMenu],
["TairoTopnavFooter", LazyTairoTopnavFooter],
["TairoTopnavLayout", LazyTairoTopnavLayout],
["TairoTopnavNavigation", LazyTairoTopnavNavigation],
["TairoLogo", LazyTairoLogo],
["TairoLogoText", LazyTairoLogoText],
["TairoToaster", LazyTairoToaster],
["TairoTocAnchor", LazyTairoTocAnchor],
["TairoCheckAnimated", LazyTairoCheckAnimated],
["TairoContentWrapper", LazyTairoContentWrapper],
["TairoContentWrapperTabbed", LazyTairoContentWrapperTabbed],
["TairoError", LazyTairoError],
["TairoFlexTable", LazyTairoFlexTable],
["TairoFlexTableCell", LazyTairoFlexTableCell],
["TairoFlexTableHeading", LazyTairoFlexTableHeading],
["TairoFlexTableRow", LazyTairoFlexTableRow],
["TairoFormGroup", LazyTairoFormGroup],
["TairoFormSave", LazyTairoFormSave],
["TairoModal", LazyTairoModal],
["TairoPanels", LazyTairoPanels],
["TairoPasswordStrength", LazyTairoPasswordStrength],
["TairoPopover", LazyTairoPopover],
["TairoPopoverContentDual", LazyTairoPopoverContentDual],
["TairoPopoverContentHelp", LazyTairoPopoverContentHelp],
["TairoPopoverContentMedia", LazyTairoPopoverContentMedia],
["TairoTable", LazyTairoTable],
["TairoTableCell", LazyTairoTableCell],
["TairoTableHeading", LazyTairoTableHeading],
["TairoTableRow", LazyTairoTableRow],
["TairoToc", LazyTairoToc],
["Icon", LazyIcon],
["IconCSS", LazyIconCSS],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
